import styled from "styled-components";

export const FileUplaodStyles = styled.div`
  .inputContainer {
    background: ${({ theme }) => theme.colors.semantic.container.white};
    border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
    border-radius: ${({ theme }) => theme.radius[4]};
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 3px;

    /* 4px vertical padding keeps the field's height equal to TextField (38px). */
    .addButton {
      font-weight: 600;
      padding: ${({ theme }) => theme.spacing[4]} 12.5px;

      &:hover {
        background: ${({ theme }) => theme.colors.semantic.text.strong};
        color: ${({ theme }) => theme.colors.semantic.accent.onAccent};
        border: 1px solid ${({ theme }) => theme.colors.semantic.text.strong};
      }
    }

    /* Override the DANGER 6px padding so the filled state matches too. */
    .delete {
      padding: ${({ theme }) => theme.spacing[4]} 9px;
    }

    .valueContainer {
      padding: 5px 6px;
      display: flex;
      align-items: center;
      width: ${({ $value }) => $value && "calc(100% - 40px)"};

      .value {
        font-style: normal;
        font-weight: ${({ theme }) => theme.typography.body.b2.weight};
        font-size: ${({ theme }) => theme.typography.body.b2.size};
        line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
        color: ${({ theme }) => theme.colors.semantic.text.strong};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        opacity: ${({ $value }) => ($value ? "1" : "0.5")};
        width: 100%;
      }

      .valueTextColor {
        color: ${({ theme }) => theme.colors.semantic.text.strong};
      }
    }
  }

  .error {
    border: 1px solid ${({ theme }) => theme.colors.semantic.text.error} !important;
  }

  .errorMessage {
    font-style: normal;
    font-weight: ${({ theme }) => theme.typography.caption.c1.weight};
    font-size: ${({ theme }) => theme.typography.body.b2.size};
    line-height: ${({ theme }) => theme.typography.body.b1.lineHeight};
    color: ${({ theme }) => theme.colors.semantic.text.error};
    margin-top: ${({ theme }) => theme.spacing[4]};
    height: 24px;
  }

  .delete:hover path {
    fill: ${({ theme }) => theme.colors.semantic.accent.onAccent};
  }
`;
